import { INSTRUCTOR_UPDATE_ADMIN_ID, RESET_ADMIN_STATE } from "../actions/types"

const INITIAL_STATE = {
  instructorId: null,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INSTRUCTOR_UPDATE_ADMIN_ID:
      return { ...state, instructorId: action.payload }
    case RESET_ADMIN_STATE:
      return INITIAL_STATE
    default:
      return state
  }
}
